/*
 * O picote do carnê como divisor — motivo de assinatura 2 do doc 06a §3.6.
 *
 * "No lugar de `border-top` comum entre seções, o tracejado do carnê — traço
 * curto, respiro largo, meia-lua recortada nas duas pontas. Identidade em cada
 * divisória, custo zero de espaço."
 *
 * Desenhado com gradiente e dois círculos em `--breu`, e não com imagem: escala
 * em qualquer largura, não pesa um pedido de rede e não desalinha em zoom.
 *
 * `aria-hidden` porque é ornamento: um leitor de tela anunciando "separador" a
 * cada divisória transforma a leitura da tela numa lista de separadores.
 */
export function Picote({ className = "" }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`relative h-[9px] w-full select-none ${className}`}
    >
      <div className="picote-linha absolute inset-x-0 top-1/2 h-px -translate-y-1/2" />
      <Furo lado="left" />
      <Furo lado="right" />
    </div>
  );
}

function Furo({ lado }: { lado: "left" | "right" }) {
  return (
    <span
      className={[
        "absolute top-1/2 size-[9px] -translate-y-1/2 rounded-full bg-breu",
        lado === "left" ? "picote-furo-esq" : "picote-furo-dir",
      ].join(" ")}
    />
  );
}
